import PropTypes from 'prop-types';
import { withSiteMap, siteMapPropType, findSelectedNode } from '@bingads-webui-campaign-react/with-site-map';

const PageTitleUpdater = ({ siteMap, i18n }) => {
  const selectedNode = findSelectedNode(siteMap);
  let newTitle = 'Microsoft Advertising';

  if (selectedNode) {
    newTitle = `${i18n.getString(selectedNode.name)} | Microsoft Advertising`;
  }

  document.title = newTitle;

  return null;
};

PageTitleUpdater.propTypes = {
  siteMap: siteMapPropType.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};

const wrapped = withSiteMap(PageTitleUpdater);

export { wrapped as PageTitleUpdater };
